import { getToken, net } from '../../admincore'
import { API_URL, AUTH_URL } from '../../utils/constants'

const { get, postJson } = net

// eslint-disable-next-line
export const getScheduledOrders = (companyId, params) => get(`${API_URL}/${companyId}/scheduled`, params, getToken())
export const employees = (companyId, params) => get(`${API_URL}/${companyId}/employees`, params, getToken())
export const searchAddressWithNo = params => postJson(`${AUTH_URL}/searchAddress?layers=address,venue&lat=44.43&lng=26.1&text=${params}`, params, getToken())

export const createOrder = (companyId, params) => postJson(`${API_URL}/${companyId}/orders`, params, getToken())
